module.exports = __webpack_public_path__ + "media/images/emblems/Grandvillard-coat_of_arms-a4e25e1a4308f1a8ec1835572ca84dad.svg";